import { ExchangeRateTab } from "@/modules/exchangeRate/common/enum";
import type { ITabItemsProps } from "@/shared/common/types";

export const getExchangeRateTabItems = ({ t }: ITabItemsProps) => [{
  value: ExchangeRateTab.NonCash,
  label: t("dashboard.exchangeRate.nonCash"),
  dataId: "non-cash-tab",
  disabled: false,
},
  {
    value: ExchangeRateTab.Cash,
    label: t("dashboard.exchangeRate.cash"),
    dataId: "cash-tab",
    disabled: false,
  }];
